/**
*  UI-REFACTORED
*    FROM --> ./legacy-web/src/main/js/js/aa/modules/createNotification.js
*    TO   --> ./webapps/shared-web/src/main/assets/js/modules/create-notification.js
**/

AAcom.modules.notification = function(AAUI) {

    var submitButton = AAUI.getProperty('fsnSubmitButton'),
        cancelButton = AAUI.getProperty('fsnCancelButton'),
        closeButton = AAUI.getProperty('fsnCloseButton'),
        savingText = AAUI.getProperty('fsnSavingText'),
        errorMessages = AAUI.getProperty('fsnMessages'),
        nativeTextUSDisclaimer = AAUI.getProperty('nativeTextUSDisclaimer'),
        nativeTextESDisclaimer = AAUI.getProperty('nativeTextESDisclaimer'),
        nativeTextGBDisclaimer = AAUI.getProperty('nativeTextGBDisclaimer'),
        fsnPrintParams = null,
        fsnPrintParamsWithConfirmation = null,
        originalMultipleValidationMessage = $j('#multipleErrorHeader').text();

    AAUI.fsnSaveButtonClickEventHandler = function() {
        var emailInput = '';
        var emailMask = '***';
        var emailSplitKey = '@';
        var visibleTextInput = 4;
        var textInput = '';
        var departureCheck = '';
        var arrivalCheck = '';

        if($j('input[name=contactTypeSelect]:checked').val() == 'email') {
            emailInput = $j('#emailMessageContactId').val();

            var arrEmailInput = emailInput.trim().split(emailSplitKey);

            if(arrEmailInput[0].length > 3) {
                emailMask += arrEmailInput[0].slice(-3);
            }

            var maskedEmail = emailMask + emailSplitKey + arrEmailInput[1];

            $j('#contactInput').text(maskedEmail);
        }
        else if($j('input[name=contactTypeSelect]:checked').val() == 'native') {
            switch ($j('#textMessageCountryCode :selected').val()) {
                case 'US' :
                    textInput += '1 ';
                    break;
                case 'ES' :
                    textInput += '34 ';
                    break;
                case 'GB' :
                    textInput += '44 ';
                    break;
            }

            textInput += $j('#textMessagePhoneNumber').val();

            var hiddenTextInput = textInput.substring(0, textInput.length - visibleTextInput);
            var maskedTextInput = hiddenTextInput.replace(/./g, '*') + textInput.slice(-visibleTextInput);

            $j('#contactInput').text(maskedTextInput);
        }

        $j('#tcandprivacyhiddentext').show();
        $j('#tcandprivacyhiddentext').addClass('hidden-accessible');
        // See what checkbox was checked, only display summary for the checked item
        if($j('input[name=notificationEventType]:checked').val() == 'departureNotification') {
            $j('#confDepartSummary').show();
        }
        if($j('input[name=arrivalNotificationCheckbox]:checked').val() == 'arrivalNotification') {
            $j('#confArriveSummary').show();
        }

        $j('[aria-describedby=\'createFsnDialog\']').aaBusy({message: savingText}).start();
        var result = AAUI.fsnAjaxSubmitForm($j('#createNotificationForm'));
        $j('[aria-describedby=\'createFsnDialog\']').aaBusy().stop();

        if(result) {
            AAUI.resetFormStyles();
            AAUI.fsnShowConfirmationDialog();
        }
    };

    AAUI.initCreateFsnDialog = function() {
        var buttonsArr = [];
        buttonsArr[0] = {
            name: submitButton,
            cssClass: 'btn',
            callback: AAUI.fsnSaveButtonClickEventHandler,
            closeDialog: false
        };
        buttonsArr[1] = {
            name: cancelButton,
            cssClass: 'btn btn-secondary',
            callback: AAUI.fsnCleanForms,
            closeDialog: true
        };
        AAUI.util.aaDialog('createFsn', {
            width: '925',
            height: 'auto',
            buttons: buttonsArr,
            toggleScroll: true,
            autoOpen: false,
            onClose: function() {
                AAUI.fsnCleanForms();
                $j('#radioEmail').prop('checked', true);
            }
        });

    };

    AAUI.initFsnConfirmationDialog = function() {
        var buttonsArr1 = [];
        buttonsArr1[0] = {
            name: closeButton,
            cssClass: 'btn',
            callback: AAUI.fsnCleanForms,
            closeDialog: true
        };
        AAUI.util.aaDialog('fsnConfirmation', {
            width: '925',
            height: 'auto',
            buttons: buttonsArr1,
            toggleScroll: true,
            autoOpen: false,
            onClose: function() {
                AAUI.fsnCleanForms();
                $j('#radioEmail').prop('checked', true);
            }
        });
    };

    AAUI.initmobileFSNDialog = function() {
        var buttonsArr = [];
        buttonsArr[0] = {
            name: submitButton,
            cssClass: 'btn',
            callback: AAUI.fsnSaveButtonClickEventHandler,
            closeDialog: false
        };
        buttonsArr[1] = {
            name: cancelButton,
            cssClass: 'btn btn-secondary',
            callback: AAUI.fsnCleanForms,
            closeDialog: true
        };
        AAUI.util.aaDialog('mobileFSN', {
            width: '325',
            height: 'auto',
            buttons: buttonsArr,
            toggleScroll: true,
            autoOpen: false,
            onClose: function() {
                AAUI.fsnCleanForms();
            }
        });

    };

    AAUI.showGlobalMessage = function(i, j) {
        if(i == 'globalMessage') {
            $j('[globalMessage=true]').removeClass('is-hidden');
            $j('[globalMessage=true]').addClass('message-inline-error');
            $j('[globalMessage=true]').html(errorMessages[j] + '<br/><br/>');
        }
    };

    AAUI.showValidationMessages = function(data) {
        var result = true;
        $j('#errorHeaderDisplay').hide();
        $j('[id$=ErrorLink]').hide();
        var validationErrorCount = 0;

        for(var id in data) {
            ++validationErrorCount;
            result = false;
            $j('#' + id + 'ErrorText').html(errorMessages[data[id]]);
            AAUI.showGlobalMessage(id, data[id]);

            $j('#' + id + 'ErrorText').removeClass('is-hidden');
            $j('#' + id + 'ErrorText').addClass('is-error');

            AAUI.setErrorLabelStyle(id);
            AAUI.showFieldErrorLink(id);

        }

        AAUI.showErrorHeader(validationErrorCount);
        $j(window).resize();
        $j('#errorHeaderDisplay').focus();
        return result;
    };

    AAUI.setErrorLabelStyle = function(id) {
        if(id == 'textMessageCountryCode' || id == 'textMessagePhoneNumber') {
            $j('#textPhoneFieldset').addClass('is-error');
            $j('.textMessageCountryCodeLabel').addClass('is-error');
        }
        $j('#' + id + 'ErrorIcon').show();
        $j('#' + id + 'Label').addClass('is-error');
    };

    AAUI.showFieldErrorLink = function(id) {
        $j('#' + id + 'ErrorLink').show();
    };

    AAUI.showErrorHeader = function(validationErrorCount) {
        $j('#errorHeaderDisplay').show();
        $j('#errorNotification').show();
        if(validationErrorCount == 1) {
            $j('#singleErrorHeader').show();
            $j('#multipleErrorHeader').hide();
        }else if(validationErrorCount > 1) {
            $j('#multipleErrorHeader').html(originalMultipleValidationMessage.replace('{0}', validationErrorCount));
            $j('#singleErrorHeader').hide();
            $j('#multipleErrorHeader').show();
        }
    };

    AAUI.resetFormStyles = function() {
        $j('[id$=Label]').removeClass('is-error');
        $j('[id$=ErrorText]').html('');
        $j('[id$=ErrorText]').removeClass('is-error');
        $j('[id$=ErrorText]').addClass('is-hidden');
        $j('[globalMessage=true]').addClass('is-hidden');
        $j('[globalMessage=true]').removeClass('message-inline-error');
        $j('[globalMessage=true]').html('');
        $j('#textPhoneFieldset').removeClass('is-error');
        $j('.textMessageCountryCodeLabel').removeClass('is-error');
        $j('[id$=ErrorIcon]').hide();

        //error summary
        $j('.errorName').remove();
        $j('#errorNotification').hide();
        $j('#errorHeader408').hide();
        $j('#errorHeader409').hide();
        $j('#sysErrorNotification').hide();
        $j('#sysErrorNotificationConf').hide();

    };

    AAUI.fsnCleanForms = function() {
        $j('#textMessagePhoneNumber').val('');
        $j('#tcAgreementCheckbox').removeAttr('checked');
        $j('#emailMessageContactId').val('');
        $j('#confirmEmailMessageContactId').val('');
        $j('#arrivalNotificationCheckbox').removeAttr('checked');

        $j('#textMessageCountryCode').val('-');
        $j('#fsnUnavailable').hide();
        $j('#nativeTextDisclaimer').html('');
        $j('#textNotification').hide();
        $j('#privpolicyterms').hide();
        $j('#agreeCheck').hide();

        $j('#emailNotification').show();
        $j('#textNotification').hide();
        $j('#privpolicyterms').hide();
        $j('#agreeCheck').hide();
        $j('#radioEmail').prop('checked', true);
        $j('#textMessageCountryCode').prop('selectedIndex', 0).trigger('change');

        AAUI.fsnPreLoadAdvantageValues();
        AAUI.resetFormStyles();
    };

    AAUI.fsnPreLoadAdvantageValues = function() {
        AAUI.fsnPreLoadEmail();
        AAUI.fsnPreLoadCountryCode();
        AAUI.fsnPreLoadPhoneNumber();
    };

    AAUI.fsnPreLoadEmail = function() {
        var preloadedEmailMessageContactId = $j('#hiddenEmailMessageContactId').val();
        $j('#emailMessageContactId').val(preloadedEmailMessageContactId);
        $j('#confirmEmailMessageContactId').val(preloadedEmailMessageContactId);
    };

    AAUI.fsnPreLoadCountryCode = function() {
        var preloadedCountryCode = $j('#hiddenTextMessageCountryCode').val();
        var preloadIndex = $j('#textMessageCountryCode option[value=\'' + preloadedCountryCode + '\']').index();

        $j('#textMessageCountryCode').prop('selectedIndex', preloadIndex).trigger('change');
    };

    AAUI.fsnPreLoadPhoneNumber = function() {
        var preloadedPhoneNumber = $j('#hiddenTextMessagePhoneNumber').val();
        $j('#textMessagePhoneNumber').val(preloadedPhoneNumber);
    };

    AAUI.fsnShowConfirmationDialog = function() {

        if($j('#contactTypeSelect').val() == '-') {
            $j('#fsnContactType').html('');
        }else{
            $j('#fsnContactType').html($j('#contactTypeSelect :selected').text());
        }

        var contactInformation = '';

        $j('#fsnContactTypeValue').html(contactInformation);

        if(typeof AAUI.util !== 'undefined') {
            AAUI.util.aaDialog('#fsnConfirmationDialog').openDialog();
        }else{
            $j('#createFsnDialog').hide();
            $j('#createFSNBtns').hide();
            $j('#fsnConfirmationDialog').show();
            $j('#closeFSNBtns').show();
        }
    };

    AAUI.fsnAjaxSubmitForm = function(form) {
        var result = false;
        $j.ajax({
            url: form.attr('action'),
            type: form.attr('method'),
            timeout: 30000,
            async: false,
            data: form.serialize(),
            success: function(data) {
                if(typeof data == 'object') {
                    AAUI.resetFormStyles();
                    result = AAUI.showValidationMessages(data.messages);

                    if(result) {
                        if(data.confirmationCode == '') {
                            result = false;
                            AAUI.resetFormStyles();
                            $j('#sysErrorNotification').show();
                            $j(window).resize();
                        }else{
                            AAUI.resetFormStyles();
                            $j('#confirmationSaved').show().focus();
                            $j('#deleteLink').show();
                            $j('#confirmationDeleted').hide();
                            $j('#confirmationCode').html(data.confirmationCode);
                        }
                    }
                }else{
                    result = false;
                    $j('#sysErrorNotification').show();
                }
            },
            error: function(xhr, err) {
                alert('Error: ' + xhr.status + ' ' + xhr.statusText);
                $j('#sysErrorNotification').show();
                return false;
            }
        });
        return result;
    };

    AAUI.fsnAjaxSubmitDelete = function(confirmationCode) {
        var result = false;
        $j.ajax({
            url: '/reservations/deleteNotification/submit?confirmationCode=' + confirmationCode,
            type: 'GET',
            timeout: 30000,
            async: false,
            data: null,
            success: function(data) {
                // we need to see if there are error messages in "data"
                // if there are no errors, then the delete succeeded
                // if there is one or more error messages, then the delete failed for some reason.
                if(data.messages.globalMessage != null) {
                    $j('#sysErrorNotificationConf').show();
                    $j('#sysErrorNotificationConf').focus();
                    $j('.infoGreen').hide();
                    result = false;
                    $j(window).resize();
                }else{
                    $j('#confirmationSaved').hide();
                    $j('#deleteLink').hide();
                    $j('#confirmationDeleted').show();
                    $j('#confirmationDeleted').focus();
                    result = true;
                }
            },
            error: function(xhr, err) {
                alert('Error: ' + xhr.status + ' ' + xhr.statusText);
                $j('#sysErrorNotificationConf').show();
                return false;
            }
        });
        return result;
    };

    function init() {
        $j('#textNotification').hide();
        $j('#privpolicyterms').hide();
        $j('#agreeCheck').hide();
        $j('#sysErrorNotification').hide();
        $j('#sysErrorNotificationConf').hide();
        $j('#tcandprivacyhiddentext').hide();
        AAUI.onChange('#textMessageCountryCode', function() {
            if($j(this).val() == 'US') {
                $j('#nativeTextDisclaimer').html(nativeTextUSDisclaimer);
            }else{
                if($j(this).val() == 'ES') {
                    $j('#nativeTextDisclaimer').html(nativeTextESDisclaimer);
                }else{
                    if($j(this).val() == 'GB') {
                        $j('#nativeTextDisclaimer').html(nativeTextGBDisclaimer);
                    }else{
                        $j('#nativeTextDisclaimer').html('');
                    }
                }
            }
        });

        AAUI.onChange('#radioEmail', function() {

            //load we possible pre-load value
            AAUI.fsnPreLoadEmail();

            $j('#emailNotification').show();
            $j('#textNotification').hide();
            $j('#privpolicyterms').hide();
            $j('#agreeCheck').hide();
            $j(window).resize();

            //clear out old values
            $j('#textMessageCountryCode').prop('selectedIndex', 0).trigger('change');
            $j('#textMessagePhoneNumber').val('');
            $j('#tcAgreementCheckbox').removeAttr('checked');

            AAUI.resetFormStyles();
        });

        AAUI.onChange('#radioText', function() {

            //load we possible pre-load value
            AAUI.fsnPreLoadCountryCode();
            AAUI.fsnPreLoadPhoneNumber();
            $j('#emailNotification').hide();
            $j('#textNotification').show();
            $j('#privpolicyterms').show();
            $j('#agreeCheck').show();
            $j(window).resize();
            $j('#tcandprivacyhiddentext').hide();
            //clear out old values
            $j('#emailMessageContactId').val('');
            $j('#confirmEmailMessageContactId').val('');

            AAUI.resetFormStyles();

        });

        AAUI.onClick('#deleteLink', function() {
            AAUI.fsnAjaxSubmitDelete($j('#confirmationCode').text());
        });

    }

    function initDialog(selector) {
        if(typeof selector === 'undefined') {
            return;
        }

        AAUI.util = new aa_Utilities();
        AAUI.initCreateFsnDialog();
        AAUI.initFsnConfirmationDialog();

        AAUI.onClick(selector, function() {

            AAUI.util.aaDialog('#createFsnDialog')
            .openDialog();

            // FlightStatus re-skin vars
            $j('#fsDepartureCity').html($j(this).attr('fromCity'));
            $j('#fsArrivalCity').html($j(this).attr('toCity'));
            $j('#fsFlightInfoDepart').html($j(this).attr('depart'));
            $j('#fsFlightInfoDepartureTime').html($j(this).attr('departureTime'));
            $j('#fsFlightInfoArrivalTime').html($j(this).attr('arrivalTime'));
            $j('#fsDepartCityCode').html($j(this).attr('from'));
            $j('#flightInfoTo1').html($j(this).attr('to')); // old fsArriveCityCode
            $j('#fsFlightInfoAirlineName').html($j(this).attr('airlineName'));
            $j('#readerAirlineName').html($j(this).attr('airlineName'));
            $j('#readerFlightNumber').html($j(this).attr('flightNumber'));
            $j('#fsFlightNumber').html($j(this).attr('flightNumber'));
            $j('#fsOperationalDisclosure').html($j(this).attr('operationalDisclosure'));
            $j('#confDepartSummary').hide();
            $j('#confArriveSummary').hide();

            // Summary flight panel population
            $j('#fsDepartureCityConf').html($j(this).attr('fromCity'));
            $j('#fsArrivalCityConf').html($j(this).attr('toCity'));
            $j('#fsFlightInfoDepartConf').html($j(this).attr('depart'));
            $j('#fsFlightInfoDepartureTimeConf').html($j(this).attr('departureTime'));
            $j('#fsFlightInfoArrivalTimeConf').html($j(this).attr('arrivalTime'));
            $j('#fsDepartCityCodeConf').html($j(this).attr('from'));
            $j('#flightInfoTo1Conf').html($j(this).attr('to'));
            $j('#fsFlightInfoAirlineNameConf').html($j(this).attr('airlineName'));
            $j('#fsFlightNumberConf').html($j(this).attr('flightNumber'));
            $j('#fsOperationalDisclosureConf').html($j(this).attr('operationalDisclosure'));
            $j('#readerAirlineNameConf').html($j(this).attr('airlineName'));
            $j('#readerFlightNumberConf').html($j(this).attr('flightNumber'));

            // Hide operationalDisclosure if it's coming back null
            if(!$j(this).attr('operationalDisclosure')) {
                $j('#showOpDisclosure').hide();
            }else{
                $j('#showOpDisclosure').show();
            }

            // Hide operationalDisclosure if it's coming back null
            if(!$j(this).attr('operationalDisclosure')) {
                $j('#showOpDisclosureConf').hide();
            }else{
                $j('#showOpDisclosureConf').show();
            }

            // if the parent page didn't supply isDepartureAlertAvailable or if they supplied it and it was true,
            // then we show the departure alert checkbox
            var isDepartureAvailable = $j(this).attr('isDepartureAlertAvailable') === undefined ||
                ($j(this).attr('isDepartureAlertAvailable') === 'true');
            if(isDepartureAvailable) {
                $j('#departureAndArrivalCheckboxes').show();
                $j('#arrivalCheckboxOnly').hide();
                $j('#notificationEventType').prop('checked', true);
                $j('#arrivalNotificationCheckbox').prop('checked', false);
            }else{
                $j('#departureAndArrivalCheckboxes').hide();
                $j('#arrivalCheckboxOnly').show();
                $j('#notificationEventType').prop('checked', false);
                $j('#arrivalNotificationCheckbox').prop('checked', true);
            }

            // Original stuff populated into hidden inputs
            $j('#flightInfoTo').val($j(this).attr('to'));
            $j('#flightInfoFrom').val($j(this).attr('from'));
            $j('#flightInfoDepart').val($j(this).attr('depart'));
            $j('#flightInfoFlightNumber').val($j(this).attr('flightNumber'));
            $j('#flightInfoDepartMillis').val($j(this).attr('sliceTravelDateMillis'));
            $j('#flightInfoOperationalDisclosure').val($j(this).attr('operationalDisclosure'));
            $j('#flightInfoDepartureTime').val($j(this).attr('departureTime'));
            $j('#flightInfoArrivalTime').val($j(this).attr('arrivalTime'));
            $j('#flightInfoAirlineName').val($j(this).attr('airlineName'));

            $j('#departureFlightNumber').html($j(this).attr('flightNumber'));
            $j('#departureCity').html($j(this).attr('fromCity') + ' (' + $j(this).attr('from') + ')');
            $j('#arrivalCity').html('to ' + $j(this).attr('toCity') + ' (' + $j(this).attr('to') + ')');
            $j('#departureDate').html($j(this).attr('depart'));

            fsnPrintParams = 'originAirportCode=' + $j(this).attr('from');
            fsnPrintParams += '&originAirportCity=' + $j(this).attr('fromCity');
            fsnPrintParams += '&destinationAirportCode=' + $j(this).attr('to');
            fsnPrintParams += '&destinationAirportCity=' + $j(this).attr('toCity');
            fsnPrintParams += '&flightDate=' + $j(this).attr('depart');
            fsnPrintParams += '&recordLocator=null';
            var disableStatusArray = ['flight.status.awaitingTakeoff', 'flight.status.delayedAwaitingTakeoff', 'flight.status.inFlight', 'flight.status.delayedInFlight'];
            if(disableStatusArray.includes($j(this).attr('flightStatus'))) {
                $j('#departureEnable').hide();
                $j('#notificationEventType').prop('checked', false);
                $j('#arrivalCheckboxOnly').hide();
                $j('#arrivalNotificationCheckbox').prop('checked', true);
                $j('#departureAndArrivalCheckboxes').hide();
                $j('#arrivalCheckboxOnly').show();
            } else {
                $j('#departureEnable').show();
                $j('#notificationEventType').prop('checked', true);
            }
        });

    }

    function getFlightInfo(flightInfo) {

        if(!flightInfo) {
            return null;
        }

        var $params = $j(flightInfo);
        var flight = {
            fromCity: $params.data('fromcity'),
            toCity: $params.data('tocity'),
            depart: $params.data('depart'),
            departureTime: $params.data('departuretime'),
            arrivalTime: $params.data('arrivaltime'),
            from: $params.data('from'),
            to: $params.data('to'),
            airlineName: $params.data('airlinename'),
            flightNumber: $params.data('flightnumber'),
            flightStatus: $params.data('flightStatus'),
            operationalDisclosure: $params.data('operationaldisclosure'),
            sliceTravelDateMillis: $params.data('slicetraveldatemillis')
        }

        return flight;
    }

    function initpopup(selector) {

        if(!window.opener || !window.opener.selectedFlight) {
            return;
        }

        $j('#createFsnDialog').show();

        var queryMap = getFlightInfo(window.opener.selectedFlight);
        if(!queryMap) {
            return;
        }

        // FlightStatus re-skin vars
        $j('#fsDepartureCity').html(queryMap.fromCity);
        $j('#fsArrivalCity').html(queryMap.toCity);
        $j('#fsFlightInfoDepart').html(queryMap.depart);
        $j('#fsFlightInfoDepartureTime').html(queryMap.departureTime);
        $j('#fsFlightInfoArrivalTime').html(queryMap.arrivalTime);
        $j('#fsDepartCityCode').html(queryMap.from);
        $j('#flightInfoTo1').html(queryMap.to); // old fsArriveCityCode
        $j('#fsFlightInfoAirlineName').html(queryMap.airlineName);
        $j('#readerAirlineName').html(queryMap.airlineName);
        $j('#readerFlightNumber').html(queryMap.flightNumber);
        $j('#fsFlightNumber').html(queryMap.flightNumber);
        $j('#fsOperationalDisclosure').html(queryMap.operationalDisclosure);

        $j('#confDepartSummary, #confArriveSummary').hide();

        // Summary flight panel population
        $j('#fsDepartureCityConf').html(queryMap.fromCity);
        $j('#fsArrivalCityConf').html(queryMap.toCity);
        $j('#fsFlightInfoDepartConf').html(queryMap.depart);
        $j('#fsFlightInfoDepartureTimeConf').html(queryMap.departureTime);
        $j('#fsFlightInfoArrivalTimeConf').html(queryMap.arrivalTime);
        $j('#fsDepartCityCodeConf').html(queryMap.from);
        $j('#flightInfoTo1Conf').html(queryMap.to);
        $j('#fsFlightInfoAirlineNameConf').html(queryMap.airlineName);
        $j('#fsFlightNumberConf').html(queryMap.flightNumber);
        $j('#fsOperationalDisclosureConf').html(queryMap.operationalDisclosure);
        $j('#readerAirlineNameConf').html(queryMap.airlineName);
        $j('#readerFlightNumberConf').html(queryMap.flightNumber);

        // Hide operationalDisclosure if it's coming back null
        if(!queryMap.operationalDisclosure) {
            $j('#showOpDisclosureConf').hide();
            $j('#showOpDisclosure').hide();
        }else{
            $j('#showOpDisclosureConf').show();
            $j('#showOpDisclosure').show();
        }

        // if the parent page didn't supply isDepartureAlertAvailable or if they supplied it and it was true,
        // then we show the departure alert checkbox
        var isDepartureAvailable = queryMap.isDepartureAlertAvailable === undefined ||
            queryMap.isDepartureAlertAvailable === 'true';
        if(isDepartureAvailable) {
            $j('#departureAndArrivalCheckboxes').show();
            $j('#arrivalCheckboxOnly').hide();
            $j('#notificationEventType').prop('checked', true);
            $j('#arrivalNotificationCheckbox').prop('checked', false);
        }else{
            $j('#departureAndArrivalCheckboxes').hide();
            $j('#arrivalCheckboxOnly').show();
            $j('#notificationEventType').prop('checked', false);
            $j('#arrivalNotificationCheckbox').prop('checked', true);
        }

        // Original stuff populated into hidden inputs
        $j('#flightInfoTo').val(queryMap.to);
        $j('#flightInfoFrom').val(queryMap.from);
        $j('#flightInfoDepart').val(queryMap.depart);
        $j('#flightInfoFlightNumber').val(queryMap.flightNumber);
        $j('#flightInfoDepartMillis').val(queryMap.sliceTravelDateMillis);
        $j('#flightInfoOperationalDisclosure').val(queryMap.operationalDisclosure);
        $j('#flightInfoDepartureTime').val(queryMap.departureTime);
        $j('#flightInfoArrivalTime').val(queryMap.arrivalTime);
        $j('#flightInfoAirlineName').val(queryMap.airlineName);

        $j('#departureFlightNumber').html(queryMap.flightNumber);
        $j('#departureCity').html(queryMap.fromCity + ' (' + queryMap.from + ')');
        $j('#arrivalCity').html('to ' + queryMap.toCity + ' (' + queryMap.to + ')');
        $j('#departureDate').html(queryMap.depart);

        fsnPrintParams = 'originAirportCode=' + queryMap.from;
        fsnPrintParams += '&originAirportCity=' + queryMap.fromCity;
        fsnPrintParams += '&destinationAirportCode=' + queryMap.to;
        fsnPrintParams += '&destinationAirportCity=' + queryMap.toCity;
        fsnPrintParams += '&flightDate=' + queryMap.depart;
        fsnPrintParams += '&recordLocator=null';
    }

    AAUI.initNotification = function(selector, options) {
        var settings = $j.extend({
            showAs: 'dialog'
        }, options);

        init();

        if(settings.showAs == 'dialog') {
            initDialog(selector);
        }else{
            initpopup(selector);
        }
    };
};
